"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _DateSelectionComponent = _interopRequireDefault(require("../../02_molecules/DateSelectionComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DateSelectionPopupUI = function DateSelectionPopupUI(_ref) {
  var title = _ref.title,
      date = _ref.date,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      translatorForNamespace = _ref.translatorForNamespace,
      translationManager = _ref.translationManager;
  var t = translatorForNamespace('DateSelectionPopupUI');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: title,
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_DateSelectionComponent["default"], {
    title: t('Select a date'),
    minDay: minDate,
    maxDay: maxDate,
    selectedDay: date,
    onChange: onChange,
    translationManager: translationManager
  }));
};

var _default = DateSelectionPopupUI;
exports["default"] = _default;